import * as React from "react";
import { getAuthGroups } from "app/utils/authGroups";
import * as FontAwesome from "react-fontawesome";

import BackOfficeLink from "app/components/BOComponents/BackOfficeLink";

import Dialog from "material-ui/Dialog";

import BOTable, {
  BOColumns,
  BOColumn,
  BOCell,
  BORow,
  BOBody,
  BOHeader,
} from "app/components/BOComponents/BOTable/BOTable";

export default class BODev extends React.Component<any, any> {
  selectedCheckboxes: Set<string>;

  constructor(props: any) {
    super(props);

    this.state = {
      modalOpen: false,
    };
  }

  componentDidMount() {
    this.selectedCheckboxes = new Set(getAuthGroups.asArray());
  }

  handleCheck = (e) => {
    const element = e.target;
    if (element.checked) {
      this.selectedCheckboxes.add(element.name);
    } else if (this.selectedCheckboxes.has(element.name)) {
      this.selectedCheckboxes.delete(element.name);
    }
  };

  handleSave = () => {
    localStorage.setItem(
      "devAuth",
      JSON.stringify(Array.from(this.selectedCheckboxes))
    );
    window.location.reload();
  };

  render() {
    const CheckBox = ({ name }) => (
      <input
        type="checkbox"
        name={name}
        onChange={(e) => this.handleCheck(e)}
        defaultChecked={this.selectedCheckboxes.has(name)}
      />
    );

    const accessBody = () => {
      return (
        <BOBody>
          <BORow>
            <BOCell>Fraud</BOCell>
            <BOCell>
              <CheckBox name="Fraud/Staff" />
            </BOCell>
            <BOCell>
              <CheckBox name="Fraud/Admin" />
            </BOCell>
            <BOCell>N/A</BOCell>
          </BORow>
          <BORow>
            <BOCell>IM</BOCell>
            <BOCell>
              <CheckBox name="IM/Staff" />
            </BOCell>
            <BOCell>
              <CheckBox name="IM/Admin" />
            </BOCell>
            <BOCell>N/A</BOCell>
          </BORow>
          <BORow>
            <BOCell>Ops</BOCell>
            <BOCell>
              <CheckBox name="Ops/Staff" />
            </BOCell>
            <BOCell>
              <CheckBox name="Ops/Admin" />
            </BOCell>
            <BOCell>
              <CheckBox name="Ops/UserMessaging" />
            </BOCell>
          </BORow>
          <BORow>
            <BOCell>Payserv</BOCell>
            <BOCell>
              <CheckBox name="Payserv/Staff" />
            </BOCell>
            <BOCell>
              <CheckBox name="Payserv/Admin" />
            </BOCell>
            <BOCell>N/A</BOCell>
          </BORow>
          <BORow>
            <BOCell>Settlement</BOCell>
            <BOCell>
              <CheckBox name="Settlement/Staff" />
            </BOCell>
            <BOCell>
              <CheckBox name="Settlement/Admin" />
            </BOCell>
            <BOCell>N/A</BOCell>
          </BORow>
          <BORow>
            <BOCell>TechOps</BOCell>
            <BOCell>
              <CheckBox name="TechOps/Staff" />
            </BOCell>
            <BOCell>
              <CheckBox name="TechOps/Admin" />
            </BOCell>
            <BOCell>N/A</BOCell>
          </BORow>
          <BORow>
            <BOCell>Wallet</BOCell>
            <BOCell>
              <CheckBox name="Wallet/Staff" />
            </BOCell>
            <BOCell>
              <CheckBox name="Wallet/Admin" />
            </BOCell>
            <BOCell>N/A</BOCell>
          </BORow>
        </BOBody>
      );
    };

    const dataBody = () => {
      return (
        <BOBody>
          <BORow>
            <BOCell>All</BOCell>
            <BOCell>
              <CheckBox name="Data/All" />
            </BOCell>
          </BORow>
          <BORow>
            <BOCell>Masterpass</BOCell>
            <BOCell>
              <CheckBox name="Data/Masterpass" />
            </BOCell>
          </BORow>
          <BORow>
            <BOCell>SnapScan</BOCell>
            <BOCell>
              <CheckBox name="Data/SnapScan" />
            </BOCell>
          </BORow>
          <BORow>
            <BOCell>WeChat</BOCell>
            <BOCell>
              <CheckBox name="Data/WeChat" />
            </BOCell>
          </BORow>
          <BORow>
            <BOCell>Card</BOCell>
            <BOCell>
              <CheckBox name="Data/Card" />
            </BOCell>
          </BORow>
        </BOBody>
      );
    };

    return (
      <span className="devContainer">
        <BackOfficeLink backofficeUrl={`/graphiql`}>
          Graph
          <i>i</i>
          QL
        </BackOfficeLink>

        <small
          onClick={() => this.setState({ modalOpen: true })}
          className="devButton"
        >
          <FontAwesome name="code" className="devIcon" />
          {` Groups`}
        </small>
        <Dialog
          title="Authentication Groups"
          modal={false}
          open={this.state.modalOpen}
          onRequestClose={() => this.setState({ modalOpen: false })}
          actions={[
            <input
              key="save_button"
              type="button"
              value="Save changes"
              className="button"
              onClick={this.handleSave}
            />,
          ]}
          autoScrollBodyContent={true}
        >
          <section style={{ padding: "20px" }}>
            <BOTable
              name="dev_table_access_groups"
              header={<BOHeader title="Access groups" />}
              columns={
                <BOColumns>
                  <BOColumn>Group name</BOColumn>
                  <BOColumn>Staff access</BOColumn>
                  <BOColumn>Admin access</BOColumn>
                  <BOColumn>UserMessaging access</BOColumn>
                </BOColumns>
              }
              body={accessBody()}
            />

            <BOTable
              name="dev_table_data_groups"
              header={<BOHeader title="Data groups" />}
              columns={
                <BOColumns>
                  <BOColumn>Group name</BOColumn>
                  <BOColumn>Access</BOColumn>
                </BOColumns>
              }
              body={dataBody()}
            />
          </section>
        </Dialog>
      </span>
    );
  }
}
